import React from 'react';

import appConfig from '../../config/appConfig';
import * as localizationKeys from '../../consts/localization/localizationKeys';
import {getLocalizedStrings} from '../../services/localization/localizationService';
import AppButton from '../Button/AppButton';

const ContactSupportLink = () => {
    const localizedStrings = getLocalizedStrings();

    const contactSupportUrl = appConfig.getDcsSupportUrlFormatted();

    return (
        <>
            {contactSupportUrl ? (
                <AppButton className='font-bold' tertiary to={contactSupportUrl} isExternalLink isTargetBlank>
                    {localizedStrings[localizationKeys.CONTACT_SUPPORT_LINK_TITLE_TEXT]}
                </AppButton>
            ) : (
                <span className='font-bold underline'>
                    {localizedStrings[localizationKeys.CONTACT_SUPPORT_LINK_TITLE_TEXT]}
                </span>
            )}
        </>
    );
};

export default ContactSupportLink;
